
import { defineComponent } from '@vue/runtime-core'

const LoadingIcon = defineComponent({})
export default LoadingIcon
